import clsx from 'clsx'
import React, {useContext, useState} from 'react'
import {Link, useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import {faFileExport} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {TeacherContext} from 'teacher/context'
import PreviewQuestion from 'components/quiz/components/preview-question'

import {createPost} from 'helpers/command'
import {isEmpty} from 'helpers/utils'

import Settings from './settings'

const useStyles = makeStyles(questionStyles)

export default function Question(props) {

  const [expanded, setExpanded] = useState(false)
  const history = useHistory()
  const classes = useStyles()
  const context = useContext(TeacherContext)
  const {courseName, typeName, repository, owned, textpremise, shared} = props
  const {translate, updateState} = context

  const expandClick = () => setExpanded(!expanded)

  const premiseLabel = isEmpty(textpremise) ? translate(typeName) : textpremise

  function handleSelectQuestion() {
    props.onSelect && props.onSelect(props.id)
  }

  React.useEffect(() => {
    if (isEmpty(textpremise)) setExpanded(true)
  }, [textpremise])

  return (
    <Box className={clsx(classes.root, {expanded})} >
      <Box className={classes.header}>
        <Box className={classes.filler} />
        <Box className={classes.expand}>
          <Button className={classes.button} startIcon={expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />} onClick={expandClick} >{translate(expanded ? 'view-less' : 'view-more')}</Button>
        </Box>
        <Box className={classes.splitWrapper}>
          <Box className={classes.split} />
        </Box>
        <Box className={classes.selectWrapper}>
          <Box className={classes.selectLink} onClick={handleSelectQuestion}>
            <Box className={classes.selectIcon}><FontAwesomeIcon icon={faFileExport} /></Box>
            <Box className={classes.selectText}>{translate('select')}</Box>
          </Box>
        </Box>
      </Box>
      {!expanded && (<Box className={classes.textPremise}>{premiseLabel}</Box>)}
      {expanded && (<Box className={classes.content}>
        <PreviewQuestion headless showPoints showStandards context={context} question={props} />
      </Box>)}
      <Box className={classes.footer}>
        <Box className={classes.courseName}>{translate('course_assessment_header')}: {courseName}</Box>
        <Box className={classes.type}>{translate('type-header')}: {translate(typeName)}</Box>
        <Box className={classes.repository}>{translate('repository')}: {translate(owned ? 'personal' : repository)}</Box>
      </Box>
    </Box>
  )
}

function questionStyles() {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }

  return {
    root: {
      marginTop: 10,
      '&:first-child': {
        marginTop:0
      },
      display: 'flex',
      flexDirection: 'column',
      border: 'solid 1px #becfd7',
      width: '100%',
      backgroundColor: '#fff',
    },
    button: {
      color: '#2a92eb',
      fontSize: '9pt',
      textTransform: 'none',
      '& .MuiButton-startIcon': {
        marginRight: 5
      }
    },
    header: {
      padding: 10,
      display: 'flex',
      '& > div': {
        ...verticalCentering
      }
    },
    filler: {
      flexGrow: 1
    },
    split: {
      marginLeft: 15,
      marginRight: 15,
      backgroundColor: '#d4d3d9',
      width: 1,
      height: '45%'
    },
    selectLink: {
      display: 'flex',
      marginRight: 20,
      cursor: 'pointer',
      color: '#4595e7',
      '&:hover': {
        textDecoration: 'underline' 
      }
    },
    selectIcon: {
      ...verticalCentering,
      marginTop: -2,
      marginRight: 6,
      fontSize: '10.5pt'
    },
    selectText: {
      ...verticalCentering,
      textAlign: 'center',
      fontSize: '9pt',
      marginRight: 10,
      width: 50,
      "&.selected": {
        color: "#fff"
      }
    },
    content: {
      '& .section': {
        border: 0
      }
    },
    textPremise: {
      fontSize: '12pt',
      color: '#494f67',
      padding: '0 20px 20px 20px'
    },
    footer: {
      display: 'flex',
      backgroundColor: '#f7fbfe',
      color: '#494f67',
      fontSize: '10.5pt',
      borderTop: 'solid 1px #cfe0e8',
      padding: '10px',
      '& > div': {
        marginLeft: 15,
        borderLeft: 'solid 1px #cfe0e8',
        paddingLeft: 15,
        '&:first-child': {
          marginLeft: 10,
          borderLeft: 0,
          paddingLeft: 0
        }
      }
    }
  }
}

